export default function scrollTopValue(
  header,
  isVisibleExtraHeader,
  chatWindowHeight,
  scrollBarTop
) {
  const windowHeight = window.innerHeight;
  const headerHeight = header.height;
  // The header part above the chat
  const bigAvatarPartialHeight = header.avatar.height - headerHeight;

  // visual improvement
  const topPosition = () => {
    if (!header.classicView) return 0;

    return scrollBarTop;
  };

  const partialHeight = windowHeight - chatWindowHeight + headerHeight + topPosition();

  // The value depends on isVisibleExtraHeader
  const heightAboveContent = isVisibleExtraHeader
    ? partialHeight + bigAvatarPartialHeight
    : partialHeight;

  return heightAboveContent;
}
